module.exports = __webpack_public_path__ + "static/media/header-blue@2x.b37a3df1.jpg";